export default {
  templateTypeManager: {
    type: {
      getFullTree: 'api/dify/docTemplateType/getFullTree',
      getTypeTree: 'api/dify/docTemplateType/getTypeTree',
      saveType: '/api/dify/docTemplateType/saveType',
      updateType: '/api/dify/docTemplateType/updateType',
      delType: '/api/dify/docTemplateType/delType',
      dynamicTree: '/api/dify/docTemplateType/dynamicTree'
    },
    template: {
      saveTemplate:'/api/dify/docTemplate/saveTemplate',
      updateTemplate: '/api/dify/docTemplate/updateTemplate',
      delTemplate: '/api/dify/docTemplate/delTemplate',
      getTemplateList: '/api/dify/docTemplate/getTemplateList',
      getFile: "/api/dify/docTemplate/getFile",
    },
  }
}
